module.exports = __webpack_public_path__ + "static/media/appoinments.934fe0db.svg";